// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconMiniLogo_icon__HyiCz","rotate":"IconMiniLogo_rotate__1WDW_"};